module.exports = __webpack_public_path__ + "img/20200507_134743.e1932b54.jpg";